import at from "lodash/at";
import { useField, useFormikContext } from "formik";
import {
  FormControl,
  MenuItem,
  TextField,
  InputAdornment,
  Tooltip,
  Checkbox,
  ListItemText,
} from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import { useTranslation } from "react-i18next";
import { ChangeEvent, ReactNode } from "react";
import { Option } from "../../../types/option";
import { findLabelByValue } from "../../../helpers/utils";

//TODO change props to formik stuff
type MultiSelectFieldProps = {
  label: string;
  data: Option[];
  infoMsg?: ReactNode;
  name: string;
};

export default function MultiSelectField({
  label,
  data,
  name,
  infoMsg,
  ...rest
}: MultiSelectFieldProps) {
  const { t } = useTranslation();
  const [field, meta] = useField(name);
  const { value: selectedValue } = field;
  const [touched, error] = at(meta, "touched", "error");
  const isError = touched && error && true;
  const { setFieldValue } = useFormikContext();

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (Array.isArray(e.target.value)) {
      let sortedArray = e.target.value.sort((a, b) => a - b);
      setFieldValue(field.name, sortedArray);
    }
  };

  return (
    <FormControl {...rest} error={isError} fullWidth>
      <TextField
        {...field}
        onChange={handleChange}
        select
        label={t(label)}
        error={isError}
        helperText={isError ? t(error) : ""}
        sx={{
          "& .MuiSelect-icon": { right: "40px !important" },
        }}
        SelectProps={{
          multiple: true,
          value: selectedValue,
          renderValue: (selected: unknown) => {
            let values: string[] = [];

            if (Array.isArray(selected)) {
              selected.forEach((element: number) => {
                values.push(t(findLabelByValue(element, data)));
              });
              return values.join(", ");
            }
          },
        }}
        InputProps={{
          endAdornment: (
            <>
              {infoMsg && (
                <InputAdornment position="end">
                  <Tooltip title={infoMsg}>
                    <HelpIcon style={{ cursor: "default" }} />
                  </Tooltip>
                </InputAdornment>
              )}
            </>
          ),
        }}
      >
        {data.map((item, index) => (
          <MenuItem disabled={item.disabled} key={index} value={item.value}>
            <Checkbox checked={field.value.indexOf(item.value) > -1} />
            <ListItemText primary={t(item.label)} />
          </MenuItem>
        ))}
      </TextField>
    </FormControl>
  );
}
